<template>
  <el-autocomplete
      :placeholder="$t('app.search_bar_placeholder') + '...'"
      :trigger-on-focus="false"
      :fetch-suggestions="querySearchAsync"
      v-model="searchKeyword"
      @select="handleSelect"
      clearable
      :class="isMobile ? 'search-bar-phone' : 'search-bar'"
  >
    <el-select slot="prepend" v-model="searchPlatform" v-if="!isMobile">
      <el-option v-for="{ label, value } in platforms" :key="value" :label="label" :value="value"></el-option>
    </el-select>

    <div slot-scope="{ item }">
      <i class="fa fa-gift" aria-hidden="true" v-if="item.type === 'product'"></i>
      <i class="fa fa-star" aria-hidden="true" v-if="item.type === 'brand'"></i>
      <i class="fa fa-tag" aria-hidden="true" v-if="item.type === 'tag'"></i>

      <highlight-text v-if="searchKeyword" :keyword="searchKeyword" :sensitive="false" :overWriteStyle="{ color: 'red' }">
        {{ item.name }}
      </highlight-text>
    </div>

    <el-button
        slot="append"
        class="el-input__icon el-icon-search top-search-btn" type="submit"
        @click.prevent="search(searchkeyword)"></el-button>
  </el-autocomplete>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import _ from 'lodash';
  import HighlightText from 'vue-highlight-text';
  import { Probability } from '@/plugins/helpers';
  import { SET_SEARCH_KEYWORD, SET_SEARCH_PLATFORM } from '../../store/mutation-types';

  export default {
    name: 'SearchBar',
    watch: {
      $route: {
        handler(val) {
          if (val && val.name) {
            if (~val.name.indexOf('rakuten')) {
              this.searchPlatform = 'rakuten';
            } else if (~val.name.indexOf('yahoo_jp')) {
              this.searchPlatform = 'yahoo_jp';
            } else {
              this.searchPlatform = 'local';
            }
          }

          (new Probability({
            p: this.website_search_suggests ? '50%' : 0,
            f: () => {
              const suggests = this.website_search_suggests.split(',');
              this.searchKeyword = _.shuffle(suggests).pop();
            },
          }, {
            p: this.website_search_suggests ? '50%' : '100%',
            f: () => {
              this.searchKeyword = '';
            },
          }))();
        },
        immediate: true,
      },
    },
    computed: {
      ...mapState({
        platforms: state => state.app.platforms,
        website_search_suggests: state => state.config.website_search_suggests,
        searchToolOpened: state => state.app.searchToolOpened,
      }),
      ...mapGetters([
        'isMobile',
      ]),
      searchPlatform: {
        get() {
          return this.$store.state.app.searchPlatform;
        },
        set(val) {
          this.$store.commit(SET_SEARCH_PLATFORM, val);
        },
      },
      searchKeyword: {
        get() {
          return this.$store.state.app.searchKeyword;
        },
        set(val) {
          this.$store.commit(SET_SEARCH_KEYWORD, val);
        },
      },
    },
    methods: {
      ...mapActions([
        'searchToolClose',
      ]),
      querySearchAsync(queryString, cb) {
        this.$api.keyword.query(queryString, this.searchPlatform).then(({ data: response }) => {
          cb(response);
        });
      },
      handleSelect(item) {
        const { id, name, type } = item;
        switch (type) {
          case 'product':
            this.$router.push({ name: 'product', params: { productId: id } });
            break;
          case 'brand':
            this.$router.push({ name: 'brand', params: { id, name } });
            break;
          case 'tag':
            this.$router.push({ name: 'tag', params: { id, name } });
            break;
          default:
            break;
        }
        this.searchKeyword = name;
      },
      search() {
        this.$router.push({ name: 'search', query: { keyword: this.searchKeyword } });
      },
    },
    components: {
      HighlightText,
    },
  };
</script>

<style lang="scss">
  /*@media (max-width: 960px) {*/
    /*.search-bar {*/
      /*.el-input-group__prepend {*/
        /*max-width: 100px;*/
        /*.el-select {*/
          /*padding: 0 5px 0 8px;*/
          /*.el-input__inner{*/
            /*width: 50px;*/
            /*padding: 0;*/
          /*}*/
        /*}*/
      /*}*/
    /*}*/
  /*}*/

  /*@media (max-width: 768px) {*/
    /*.search-bar {*/
      /*.el-input-group__prepend {*/
        /*max-width: 80px;*/
        /*.el-select {*/
          /*padding: 0 5px 0 8px;*/
          /*.el-input__inner{*/
            /*width: 50px;*/
            /*padding: 0;*/
          /*}*/
        /*}*/
      /*}*/
    /*}*/
  /*}*/
  .search-bar-phone{
    width: 100%;
    padding: {
      left: 5%;
      right: 5%;
    };
  }
  .search-bar {
    width: 80%;
    .el-input-group__prepend {
      border-radius: 0px;
      .el-select {
        width: 8rem;
        padding: 0 5px 0 8px;
        .el-input__inner{
          /*width: 50px;*/
          padding: 0;
        }
      }
    }
    .el-input-group__append {
      background-color: initial;
      position: absolute;
      top: 0;
      right: 0;
      width: 5%;
      height: 100%;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      .top-search-btn{
        padding: 0;
        display: flex;
        justify-content: center;
        line-height: 33px;
      }
    }

    &.hide {
      visibility: hidden!important;
    }
  }
</style>
